import React from 'react';

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { FlexRow } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { MVRLicenseInfo } from '../../../tasks/types/mvr';
import styles from '../../styles.module.scss';
import { valueToString } from '../../utilities/formattingUtilities';

export const RenderMVRLicenseInfoSection = (licenseInfo: MVRLicenseInfo) => {
  if (!licenseInfo.licenseNumber && licenseInfo.licenses.length === 0) {
    return <></>;
  }
  return (
    <>
      <FlexRow className={styles.TaskSubtitle}>
        {Resource.MVR_LICENSE_SUBTITLE}
      </FlexRow>

      <Box mb={3}>
        <TableContainer component={Paper} variant="outlined" square>
          <Table aria-label="auto-evidence-table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_NUMBER}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_STATE}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_CLASS}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_ISSUED}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_EXPIRES}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_STATUS}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="body2">
                    {Resource.MVR_LICENSE_RESTRICTIONS}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {licenseInfo.licenses.map((license, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    {valueToString(licenseInfo.licenseNumber)}
                  </TableCell>
                  <TableCell>{license.state || Resource.NORA_M_DASH}</TableCell>
                  <TableCell>
                    {license.licenseClass || Resource.NORA_M_DASH}
                  </TableCell>
                  <TableCell>
                    {license.issueDate || Resource.NORA_M_DASH}
                  </TableCell>
                  <TableCell>
                    {license.expiryDate || Resource.NORA_M_DASH}
                  </TableCell>
                  <TableCell>
                    {license.status || Resource.NORA_M_DASH}
                  </TableCell>
                  <TableCell>
                    {license.restriction || Resource.NORA_M_DASH}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};
